import { render, staticRenderFns } from "./ProcessDetailPanel.vue?vue&type=template&id=0c758424&scoped=true&"
import script from "./ProcessDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ProcessDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetailPanel.vue?vue&type=style&index=0&id=0c758424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c758424",
  null
  
)

export default component.exports